import { dataFetcher as fetcher, Endpoint } from '../../dataFetcher'
import type { Response } from './types'

export const dataFetcher = async (endpoints: Endpoint[]): Promise<Response[]> => {
  const results = await Promise.allSettled(endpoints.map((endpoint) => fetcher<Response>(endpoint)))

  const data = results
    .filter((result): result is PromiseFulfilledResult<Response> => result.status === 'fulfilled')
    .map((result) => result.value)

  return data
}
